module.exports = __webpack_public_path__ + "img/mmc_martaintoken.bb07e62.png";